import { http } from 'src/utils/http.util'

export class ZendeskService {
  static async generateJWT(): Promise<string> {
    const { data } = await http.post<{ token: string }>('/zendesk/generate-token')
    return data.token
  }
}
